import ripple from "@qpokychuk/ripple";

import fancybox from "./fancybox";
import swiper from "./swiper";
import animations from "./animations";
import scrollTo from "./scrollTo";
import theme from "./theme";
import tab from "npm-kit-tab";
import toggle from "npm-kit-toggle";
import intlTelInput from "intl-tel-input";
import EmailGenie from "email-genie";

import "intl-tel-input/build/css/intlTelInput.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import "../scss/index.scss";
import "../fonts/gotham/index.scss";

window.addEventListener("DOMContentLoaded", () => loadHandler());

function loadHandler() {
  animations.init();
  scrollTo.init();
  swiper.init();
  fancybox.init();
  theme.init();
  ripple.init();
  tab.init();
  toggle.init();
  ripple.attach(".btn");
  ripple.attach(".waved");
  ripple.deAttach(".btn-text");

  scrollHandler();
  document.addEventListener("toggleopen", toggleOpenHandler);
  document.addEventListener("toggleclose", toggleCloseHandler);

  document.querySelectorAll('input[type="tel"]').forEach((input) => {
    intlTelInput(input as HTMLInputElement, {
      loadUtils: () => import("intl-tel-input/utils"),
      autoPlaceholder: "off",
      containerClass: "form-input",
      strictMode: true,
      initialCountry: "auto",

      geoIpLookup: (callback) => {
        fetch("https://ipapi.co/json")
          .then((res) => res.json())
          .then((data) => callback(data.country_code))
          .catch(() => callback("us"));
      },
    });
  });
  document.querySelectorAll('input[type="email"]').forEach((input) => {
    new EmailGenie(input);
  });
}

window.addEventListener("scroll", scrollHandler);

function scrollHandler() {
  document.body.classList.toggle("scroll-top", window.scrollY == 0);
}

const menusIds = ["lk-menu", "menu"];

function toggleOpenHandler(e: Event) {
  const event = e as CustomEvent;

  if (menusIds.includes(event.detail.target.id)) {
    document.body.classList.add("menu-opened");
  }
}

function toggleCloseHandler(e: Event) {
  const event = e as CustomEvent;

  if (menusIds.includes(event.detail.target.id)) {
    document.body.classList.remove("menu-opened");
  }
}
